// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"7f425e03","684":"3df2aa40"}[chunkId] + ".chunk.js";
};